var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNeutralC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.52 85.04C66.0032 85.04 85.04 66.0031 85.04 42.52C85.04 19.0369 66.0032 0 42.52 0C19.0369 0 0 19.0369 0 42.52C0 66.0031 19.0369 85.04 42.52 85.04Z",
    fill: "#FCC332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.46 57.23H35.59C34.76 57.23 34.09 56.56 34.09 55.73C34.09 54.9 34.76 54.23 35.59 54.23H49.46C50.29 54.23 50.96 54.9 50.96 55.73C50.96 56.56 50.29 57.23 49.46 57.23Z",
    fill: "#331100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0999 53.86C66.2977 53.86 68.89 51.2678 68.89 48.07C68.89 44.8723 66.2977 42.28 63.0999 42.28C59.9022 42.28 57.3099 44.8723 57.3099 48.07C57.3099 51.2678 59.9022 53.86 63.0999 53.86Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9499 53.86C25.1476 53.86 27.7399 51.2678 27.7399 48.07C27.7399 44.8723 25.1476 42.28 21.9499 42.28C18.7522 42.28 16.1599 44.8723 16.1599 48.07C16.1599 51.2678 18.7522 53.86 21.9499 53.86Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.95 52.32C24.2972 52.32 26.2 50.4172 26.2 48.07C26.2 45.7228 24.2972 43.82 21.95 43.82C19.6027 43.82 17.7 45.7228 17.7 48.07C17.7 50.4172 19.6027 52.32 21.95 52.32Z",
    fill: "#331100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 52.32C65.4472 52.32 67.35 50.4172 67.35 48.07C67.35 45.7228 65.4472 43.82 63.1 43.82C60.7528 43.82 58.85 45.7228 58.85 48.07C58.85 50.4172 60.7528 52.32 63.1 52.32Z",
    fill: "#331100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNeutralC);
export default __webpack_public_path__ + "static/media/ic_neutral_c.bf6710fe4dd0e620320db202f7367527.svg";
export { ForwardRef as ReactComponent };